module.exports = __webpack_public_path__ + "img/credit.61bbb616.png";